import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import api from '../../../api/apiClient';

const VoucherUsageReport = () => {
  const { voucherId } = useParams();
  const navigate = useNavigate();

  const [usage, setUsage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [voucher, setVoucher] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const [voucherRes, usageRes] = await Promise.all([
        api.vouchers.getById(voucherId),
        api.vouchers.getUsage(voucherId, { page: 1, limit: 100 })
      ]);

      if (voucherRes.data?.success) {
        setVoucher(voucherRes.data.data);
      }

      if (usageRes.data?.success) {
        setUsage(Array.isArray(usageRes.data.data) ? usageRes.data.data : []);
      } else if (Array.isArray(usageRes.data)) {
        setUsage(usageRes.data);
      }
      // eslint-disable-next-line no-empty
    } catch (error) {} finally {
      setLoading(false);
    }
  }, [voucherId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="p-6 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 min-h-screen">

      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-6">
        <div>
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/admin/vouchers')}
              className="flex items-center gap-2 px-4 py-2 bg-white border border-purple-300 text-purple-700 rounded-lg shadow-md hover:bg-purple-50 hover:shadow-lg transition-all duration-200 text-sm font-medium"
            >
              <FaArrowLeft className="w-4 h-4" /> Back
            </button>
            <span className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Voucher Usage Report
            </span>
          </div>
        </div>

        
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-purple-100">
        {loading ? (
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-8 border-purple-600 border-t-transparent mx-auto"></div>
            <p className="mt-6 text-xl font-medium text-purple-700">Loading usage data...</p>
          </div>
        ) : usage.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-2xl font-bold text-purple-700">No usage records found.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-gradient-to-r from-purple-600 to-pink-600 text-white">
                <tr>
                  <th className="px-8 py-5 font-bold text-lg">User</th>
                  <th className="px-8 py-5 font-bold text-lg">Email</th>
                  <th className="px-8 py-5 font-bold text-lg">Course</th>
                  <th className="px-8 py-5 font-bold text-lg">Used On</th>
                </tr>
              </thead>
              <tbody>
                {usage.map((record) => (
                  <tr key={record.id} className="border-b border-purple-100 hover:bg-purple-50 transition-all">
                    <td className="px-8 py-6 font-medium text-purple-800">
                      {record.user ? `${record.user.first_name} ${record.user.last_name}` : '-'}
                    </td>
                    <td className="px-8 py-6 text-gray-700">
                      {record.user?.email || '-'}
                    </td>
                    <td className="px-8 py-6">
                      <span className="inline-block bg-purple-100 text-purple-800 px-4 py-2 rounded-full font-medium">
                        {record.course?.name || record.course?.title || '-'}
                      </span>
                    </td>
                    <td className="px-8 py-6 text-gray-700 font-medium">
                      {record.used_on ? new Date(record.used_on).toLocaleString() : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoucherUsageReport;